import "./Login.scss";
import { Row, Col } from "antd";
import Depop from "../../assets/images/Header/logo.png";
import { Link } from "react-router-dom";
import FormLogin from "../../components/FormLogin";

function Login() {
  return (
    <>
      <Row className="login-wrapper">
        <Col xxl={12} xl={12} lg={12}>
          <div className="div-left">
            <img
              src="https://images.unsplash.com/photo-1714583353759-ac534aae73ce?w=600&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8OHx8c2Vjb25kJTIwaGFuZCUyMHNob3B8ZW58MHx8MHx8fDA%3D"
              alt="Image Login"
            />
          </div>
        </Col>

        <Col xxl={12} xl={12} lg={12} md={24}>
          <div className="div-right">
            <Link to="/">
              <div className="logo-login">
                <img src={Depop} alt="Depop Logo" />
              </div>
            </Link>

            <div className="login-div">
              <div className="title">Đăng nhập</div>
              <div className="sub">
                hoặc không có tài khoản?
                <Link to="/register" className="link-register">
                  <div className="register">Đăng kí</div>
                </Link>
              </div>

              <FormLogin />
            </div>
          </div>
        </Col>
      </Row>
    </>
  );
}

export default Login;
